var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_65933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V45H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19997 16.65L11.2499 4.5L15.2999 16.65L4.5 9.225H17.9998L7.19997 16.65Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7661 4.73287L20.5982 5.65651L23.3783 2.41682L23.1057 6.77701L20.7927 2.91693L24.7661 4.73287Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9723 10.0638L24.7724 9.29862L28.5914 7.39078L26.6491 11.3039L26.0142 6.84893L28.9723 10.0638Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3593 17.5429L24.8367 15.1313L29.1017 14.9469L25.7323 17.7276L26.9696 13.4011L28.3593 17.5429Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0615 22.4288L20.7436 18.8438L24.7489 20.321L20.5669 21.5845L23.3792 18.0716L23.0615 22.4288Z",
    fill: "#FFFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_65933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.5cf1e9791434c4fc5fe5813a21ed1350.svg";
export { ForwardRef as ReactComponent };